/*
 * @Author: qx
 * @Date: 2022-10-25 13:44:27
 * @LastEditTime: 2022-10-25 14:38:39
 * @LastEditors: qx
 * @Description:
 */
import '@/utils/polyfill'
import Vue from 'vue'
import Element from 'element-ui'
import App from '@/App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import '@/icons'
import '@/element-ui/theme/index.css'
import '@/assets/scss/aui.scss'
import '@/assets/scss/flex.scss'
import '@/assets/scss/main.scss'
import '@/assets/scss/newStyle.scss'
import '@/assets/scss/quill/quill.core.css'
import '@/assets/scss/quill/quill.snow.css'
import '@/assets/scss/quill/quill.bubble.css'
import http from '@/utils/http'
import request from '@/utils/request'
import renRadioGroup from '@/components/ren-radio-group'
import renSelect from '@/components/ren-select'
import renProcessMultiple from '@/components/ren-process-multiple'
import renProcessStart from '@/components/ren-process-start'
import renProcessRunning from '@/components/ren-process-running'
import renProcessDetail from '@/components/ren-process-detail'
import renDeptTree from '@/components/ren-dept-tree'
import renRegionTree from '@/components/ren-region-tree'
import { hasPermission, getDictLabel } from '@/utils'
import cloneDeep from 'lodash/cloneDeep'
import VueLazyload from 'vue-lazyload'
import { setStorage, getStorage, removeStorage, setLocalStorage, getLocalStorage } from '@/utils/storage'
import * as filters from './filters'
import VueClipboard from 'vue-clipboard2'
import './vant'
// import 'vant/lib/index.css'
import consultJump from '@/utils/consult'
// import Cookies from 'js-cookie'
// const lang = Cookies.get('language')
// import * as Sentry from '@sentry/vue'

// 全局事件总线，创建一个vue实例，挂载到根实例
const bus = new Vue()
Vue.prototype.bus = bus

Vue.config.productionTip = false

Vue.use(renRadioGroup)
Vue.use(renSelect)
Vue.use(renDeptTree)
Vue.use(renRegionTree)
Vue.use(renProcessMultiple)
Vue.use(renProcessStart)
Vue.use(renProcessRunning)
Vue.use(renProcessDetail)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: lang === 'en-US'
//     ? require('@/assets/img/planmate_en.jpg')
//     : require('@/assets/img/planmate.jpg'),
//   loading: lang === 'en-US'
//     ? require('@/assets/img/planmate_en.jpg')
//     : require('@/assets/img/planmate.jpg'),
//   attempt: 1
// })
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/img/planmate.jpg'),
  // error: require('@/assets/img/planmate_en.jpg'),
  loading: require('@/assets/img/planmate.jpg'),
  // loading: require('@/assets/img/planmate_en.jpg'),
  attempt: 1
})
Vue.use(VueClipboard)
Vue.use(Element, {
  size: 'default',
  i18n: (key, value) => i18n.t(key, value)
})

// 挂载全局
Vue.prototype.$http = http
Vue.prototype.$request = request
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.$getDictLabel = getDictLabel
Vue.prototype.setStorage = setStorage
Vue.prototype.getStorage = getStorage
Vue.prototype.removeStorage = removeStorage
Vue.prototype.setLocalStorage = setLocalStorage
Vue.prototype.getLocalStorage = getLocalStorage
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()
Vue.prototype.$consultJump = consultJump
// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

if (process.env.VUE_APP_SENTRY_PROJECT) {
  // Sentry.init({
  //   Vue,
  //   dsn: process.env.VUE_APP_SENTRY_DSN, // 'http://0a4f72d5c5f3496986c78d19ebb263fb@1.1.1.1:9000/5',
  //   integrations: [
  //     new Sentry.BrowserTracing({
  //       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
  //       tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//]
  //     })
  //   ],
  //   // Set tracesSampleRate to 1.0 to capture 100%
  //   // of transactions for performance monitoring.
  //   // We recommend adjusting this value in production
  //   tracesSampleRate: 1.0
  // })
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
